import { DraftController } from './DraftController';
import { ThemeSelection } from './ThemeSelection';
import { StructureList } from './StructureList';
import { GraphicalVariables } from './GraphicalVariables';
import { DesignConfigurator } from '../design-configuration/DesignConfigurator';

interface ThemeConfigurationProps {
  documentId?: string;
}

export function ThemeConfiguration(_props: ThemeConfigurationProps) {
  return (
    <>
      <DraftController />
      <GraphicalVariables />
      <hr className="my-5 border-gray-300" />
      <DesignConfigurator />
      <hr className="my-5 border-gray-300" />
      <ThemeSelection />
      <hr className="my-5 border-gray-300" />
      <StructureList />
    </>
  );
}
